<div ngbDropdown #ngbDropdown="ngbDropdown" [container]="'body'">
  <button
    type="button"
    class="no-style-button toggle-button"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (mouseenter)="setIsHovered(true)"
    (mouseleave)="setIsHovered(false)"
    ngbDropdownToggle>
    <div class="d-flex align-items-center">
      <div class="button-text">{{ selectedCountry?.countryCode ?? '' }}</div>
      <img class="toggle-chevron" alt="" [src]="iconSrc$ | async" height="24" width="24" />
    </div>
  </button>
  <div ngbDropdownMenu>
    <button
      type="button"
      (focus)="onFocus()"
      (click)="onCountrySelected(country)"
      ngbDropdownItem
      *ngFor="let country of countryDropdowns | slice : 0 : 2">
      <div class="d-flex gap-2 align-items-center">
        <div *ngIf="selectedCountry === country">
          <img src="assets/icons/typeahead/Check.svg" alt="selected" i18n-alt />
        </div>
        <div class="option-name" [class.selected-option]="selectedCountry === country">
          {{ country.countryName }}
        </div>
        <div class="option-prefix">{{ country.prefix }}</div>
      </div>
    </button>
    <hr class="option-separator" />
    <button
      type="button"
      (focus)="onFocus()"
      (click)="onCountrySelected(country)"
      ngbDropdownItem
      *ngFor="let country of countryDropdowns | slice : 2">
      <div class="d-flex gap-2 align-items-center">
        <div *ngIf="selectedCountry === country">
          <img src="assets/icons/typeahead/Check.svg" alt="selected" i18n-alt />
        </div>
        <div class="option-name" [class.selected-option]="selectedCountry === country">
          {{ country.countryName }}
        </div>
        <div class="option-prefix">{{ country.prefix }}</div>
      </div>
    </button>
  </div>
</div>

<select
  class="mobile-select-input {{ interactionState$ | async }}"
  [value]="selectedCountry?.countryCode"
  (change)="onSelectChange($event)"
  (focus)="onFocus()"
  (blur)="onBlur()">
  <option *ngFor="let country of countryDropdowns">
    {{ country.countryCode }}
  </option>
</select>
